import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CrearClienteAdminDialog from "../components/CrearClienteAdminDialog";

export default function CrearCliente() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("openCrearClienteModal", handler);
    return () => window.removeEventListener("openCrearClienteModal", handler);
  }, []);

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        sx={{
          minHeight: 36,
          px: 2,
          borderRadius: "8px",
          fontSize: 12,
          fontWeight: 800,
          textTransform: "none",
          backgroundColor: "#0059f6",
          boxShadow: "0 10px 22px rgba(0, 89, 246, 0.22)",
          "&:hover": {
            backgroundColor: "#004be0",
            boxShadow: "0 12px 26px rgba(0, 89, 246, 0.28)",
          },
        }}
      >
        Crear cliente
      </Button>

      <CrearClienteAdminDialog open={open} onClose={handleClose} />
    </>
  );
}
